import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJAIImageList from '../view/FJAIImageList.jsx';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJConfig from '../../../../config/FJConfig.js';
import FJAppConstant from '../../../../constants/FJAppConstant.js';
import FJActionAIVideoGenerator from '../../../../redux/action/FJActionAIVideoGenerator.js';
import useAIListSideModelData from '../../../../hooks/useAIListSideModelData.jsx';
import FJActionAiVideoDub from '../../../../redux/action/FJActionAiVideoDub.js';

const FJAIImageListContainer = ({ position, targetIndex, absolutePosition = false }) => {
    useLocalStore();
    const dispatch = useDispatch();

    const { list, isShow, closeModal } = useAIListSideModelData();

    const itemClick = useCallback(
        (info, curMenuIndex) => {
            switch (FJConfig.appType) {
                case FJAppConstant.AI_VIDEO_GENERATOR:
                    // 首尾帧模式、多图模式 都使用 targetIndex 来确定是哪个图片
                    dispatch(FJActionAIVideoGenerator.useAIImageAction(info, targetIndex));
                    break;
                case FJAppConstant.AI_VIDEO_DUB:
                    dispatch(FJActionAiVideoDub.useAIImageAction(info, curMenuIndex));
                    break;
                default:
            }
        },
        [targetIndex],
    );

    return (
        <FJAIImageList
            active={isShow}
            closeModal={closeModal}
            list={list}
            itemClick={itemClick}
            position={position}
            absolutePosition={absolutePosition}
        />
    );
};

export default FJAIImageListContainer;
